const venues = [
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/zu53q5kn1qo1ijg2dupc',
    stadiumName: 'Eiffel Tower Stadium',
    tags: ['Beach Volleyball'],
    link: 'https://www.oneturf.news/olympics/eiffel-tower-stadium-paris-2024-olympic-games'
  },
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/e7p7mb2pxtmxw5izfcii',
    stadiumName: 'Bordeaux Stadium',
    tags: ['Artistic Gymnastics', 'Basketball', 'Trampoline'],
    link: 'https://www.oneturf.news/olympics/bordeaux-stadium-paris-2024-olympic-games-5278'
  },
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/rjzb4skmiq47xfuqwjbl',
    stadiumName: 'Bercy Arena',
    tags: ['Football', 'parties'],
    link: 'https://oneturf.news/olympics/paris-olympics-2024-know-all-about-bercy-arena'
  },
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/i70myvzy7xdcvzix0qpt',
    stadiumName: 'Champ de Mars Arena',
    tags: ['Judo', 'Wrestling'],
    link: 'https://www.oneturf.news/olympics/paris-olympics-2024-know-all-about-champ-de-mars-arena-3491'
  },
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/bx20ndrnvlssfiocnw6e',
    stadiumName: 'Aquatics Centre',
    tags: ['Artistic Swimming', 'Diving', 'Water Polo'],
    link: 'https://www.oneturf.news/olympics/aquatics-centre-paris-2024-olympic-games'
  },
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/v6t0hesg2db1d5gzqb3i',
    stadiumName: 'Paris La Defense Arena',
    tags: ['Swimming', 'Water Polo'],
    link: 'https://www.oneturf.news/olympics/paris-la-defense-arena-summer-olympics-2024'
  },
  {
    image: 'https://img.olympics.com/images/image/private/t_16-9_640/f_auto/primary/isejdmd8ox6attvfqjkg',
    stadiumName: 'Grand Palais',
    tags: ['Fencing', 'Taekwondo'],
    link: 'https://www.oneturf.news/olympics/grand-palais-summer-olympics-2024'
  }
]

export default venues
